import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41444838
const initialState: {
  order_id?: string
  pub_key?: string
  token_invalid?: boolean
} = {}

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=110332023
export const new_checkout_get_ext_info = createAsyncThunk(
  'Wallet2CheckoutNew/new_checkout_get_ext_info',
  async (params: any, store) => {
    const resp = await http.post<HiyaRes<typeof initialState>>(
      '/live/pay/new_checkout_get_ext_info',
      {...params, from: 'external_recharge'},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=110332036
export const new_create_checkout_order = createAsyncThunk(
  'Wallet2CheckoutNew/new_create_checkout_order',
  async (params: any, store) => {
    const resp = await http.post<
      HiyaRes<{
        redirect_url: string
      }>
    >(
      '/live/pay/new_create_checkout_order',
      {
        ...params,
        from: 'external_recharge',
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const Wallet2CheckoutNewSlice = createSlice({
  name: 'Wallet2CheckoutNew',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(new_checkout_get_ext_info.fulfilled, (state, action) => {
      Object.assign(state, {
        ...action.payload,
        order_id: action.meta.arg?.order_id,
      })
    })
  },
})
export const Wallet2CheckoutNewSliceActions = Wallet2CheckoutNewSlice.actions
export default Wallet2CheckoutNewSlice.reducer
export const useWallet2CheckoutNewState = () => {
  const data = useSelector((state) => state.Animal_Leopard_new)
  return data
}
